import { useQuery } from '@tanstack/react-query'
import { queryClient } from './queryClient'
import { api } from '@/app'

export const profanityWordsKey = queryClient.queryKey<string[]>(['profanityWords'])

export async function retrieveProfanityWords() {
  const response = await api.get<string[]>('adm/profanity_words/')

  return response.data
}

export const useProfanityWords = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: profanityWordsKey.key,
    queryFn: retrieveProfanityWords,
    enabled: options?.enabled
  })
}

export function prefetchProfanityWords() {
  queryClient.client.ensureQueryData({
    queryKey: profanityWordsKey.key,
    queryFn: retrieveProfanityWords
  })
}
